
/* ===== VELANTIS_REVIEWS_VIDEO — carrusel de video de reseñas (coverflow Apple v2) ===== */
(function(){
  var root=document.getElementById('rvCarousel'); if(!root) return;
  var track=document.getElementById('rvTrack'), vp=document.getElementById('rvViewport'),
      prev=document.getElementById('rvPrev'), next=document.getElementById('rvNext'),
      dots=document.getElementById('rvDots');
  var VIDEOS=["//velantis.mx/cdn/shop/t/25/assets/1e388a11-4f48-4868-89ba-c3867aa19c6f.mp4?v=131553139599236249341788483471","//velantis.mx/cdn/shop/t/25/assets/2b1c7add-eaee-4a29-bf29-676d98d330d9.mp4?v=183733152132890300141788483472","//velantis.mx/cdn/shop/t/25/assets/438d5b26-a4ea-4cca-9fd9-d82417bf582d.mp4?v=168789943529465084561788483472","//velantis.mx/cdn/shop/t/25/assets/6cc7cb83-6f71-411f-9c15-6f9ba79c1972.mp4?v=166668219582710629401788483473","//velantis.mx/cdn/shop/t/25/assets/7bed809a-7a90-4429-9717-edb1a24b06cb.mp4?v=171657212262141319631788483474","//velantis.mx/cdn/shop/t/25/assets/9367e968-5283-4727-81da-eaadc7ec1570.mp4?v=183989277549400804691788483475","//velantis.mx/cdn/shop/t/25/assets/dd39620f-cb4d-48ce-8763-7d610e82b1a0.mp4?v=141235027877998908441788483489","//velantis.mx/cdn/shop/t/25/assets/f255e6d7-73d3-4a60-a936-a28e21d777b6.mp4?v=13953602226499906491788483497"];
  var POSTERS=["//velantis.mx/cdn/shop/t/25/assets/poster-1e388a11-4f48-4868-89ba-c3867aa19c6f.jpg?v=126742132083626008111788483567","//velantis.mx/cdn/shop/t/25/assets/poster-2b1c7add-eaee-4a29-bf29-676d98d330d9.jpg?v=12096534759981764961788483568","//velantis.mx/cdn/shop/t/25/assets/poster-438d5b26-a4ea-4cca-9fd9-d82417bf582d.jpg?v=155545329823409785361788483568","//velantis.mx/cdn/shop/t/25/assets/poster-6cc7cb83-6f71-411f-9c15-6f9ba79c1972.jpg?v=91095078950057605321788483569","//velantis.mx/cdn/shop/t/25/assets/poster-7bed809a-7a90-4429-9717-edb1a24b06cb.jpg?v=54762361611343596301788483569","//velantis.mx/cdn/shop/t/25/assets/poster-9367e968-5283-4727-81da-eaadc7ec1570.jpg?v=69576382616490950411788483570","//velantis.mx/cdn/shop/t/25/assets/poster-dd39620f-cb4d-48ce-8763-7d610e82b1a0.jpg?v=137104979579817525811788483570","//velantis.mx/cdn/shop/t/25/assets/poster-f255e6d7-73d3-4a60-a936-a28e21d777b6.jpg?v=102950211802621933391788483571"];
  var idx=Math.floor(VIDEOS.length/2), vids=[], started=false, soundOn=false;
  var SPK='<svg viewBox="0 0 24 24" width="13" height="13"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="#fff"/><path d="M16.5 8.5a5 5 0 010 7" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/></svg>';
  var SND_OFF='<svg viewBox="0 0 24 24"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16 9l4 6M20 9l-4 6" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/></svg>';
  var SND_ON='<svg viewBox="0 0 24 24"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16.5 8.5a5 5 0 010 7M19 6a9 9 0 010 12" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/></svg>';

  track.innerHTML=VIDEOS.map(function(src,i){
    return '<div class="rv-slide" data-i="'+i+'">'+
      '<div class="rv-card" style="background-image:url(\''+POSTERS[i]+'\')">'+
        '<video class="rv-video" preload="none" poster="'+POSTERS[i]+'" muted loop playsinline webkit-playsinline src="'+src+'"></video>'+
        '<div class="rv-grad"></div>'+
        '<div class="rv-hint">'+SPK+' Toca para escuchar</div>'+
        '<button class="rv-sound" type="button" aria-label="Activar o silenciar sonido">'+SND_OFF+'</button>'+
      '</div></div>';
  }).join('');
  vids=[].slice.call(track.querySelectorAll('.rv-video'));
  dots.innerHTML=VIDEOS.map(function(_,i){ return '<button class="rv-dot'+(i===idx?' on':'')+'" type="button" data-i="'+i+'" aria-label="Ir al video '+(i+1)+'"></button>'; }).join('');

  function soundIcon(){ var b=track.children[idx]&&track.children[idx].querySelector('.rv-sound'); if(b) b.innerHTML=soundOn?SND_ON:SND_OFF; }
  // precarga inteligente: activo + vecinos (evita cargar los 8 y trabar la página).
  // El ACTIVO no se hace load() aquí (lo carga play(); load() interrumpiría la reproducción).
  function warm(){
    var nb={}; [idx-1,idx+1].forEach(function(k){ nb[(k+VIDEOS.length)%VIDEOS.length]=1; });
    vids.forEach(function(v,i){
      if(i===idx){ if(v.preload!=='auto') v.preload='auto'; }
      else if(nb[i]){ if(v.preload!=='auto') v.preload='auto'; if(v.readyState<2){ try{v.load();}catch(_){} } }
      else if(v.preload!=='none') v.preload='none';
    });
  }
  function center(anim){
    var slide=track.children[idx]; if(!slide) return;
    track.style.transition = anim===false ? 'none' : '';
    track.style.transform='translateX('+(vp.clientWidth/2 - (slide.offsetLeft + slide.offsetWidth/2))+'px)';
    [].forEach.call(track.children,function(s,i){
      var d=Math.abs(i-idx), card=s.querySelector('.rv-card');
      card.style.transform='scale('+Math.max(0.6,1-d*0.13)+')';
      card.style.opacity=String(Math.max(0.26,1-d*0.34));
      card.style.zIndex=String(100-d);
      s.classList.toggle('active',i===idx);
    });
    [].forEach.call(dots.children,function(d,i){ d.classList.toggle('on',i===idx); });
    if(started) warm();
    vids.forEach(function(v,i){
      if(i===idx){ v.muted=!soundOn; if(started){ var p=v.play(); if(p&&p.catch)p.catch(function(){}); } }
      else { try{v.pause();}catch(_){}; v.muted=true; }
    });
    soundIcon();
  }
  function go(i){ idx=(i%VIDEOS.length+VIDEOS.length)%VIDEOS.length; center(true); }
  prev.addEventListener('click',function(){ go(idx-1); });
  next.addEventListener('click',function(){ go(idx+1); });
  dots.addEventListener('click',function(e){ var b=e.target.closest('.rv-dot'); if(b) go(+b.dataset.i); });

  function setSound(on){ soundOn=on; root.classList.toggle('sound-on',on);
    var v=vids[idx]; if(v){ v.muted=!on; if(on){ var p=v.play(); if(p&&p.catch)p.catch(function(){}); } } soundIcon(); }
  // Gesto unificado: TAP (activar sonido / centrar) o SWIPE (cambiar de video).
  // Se maneja aquí (no con 'click') porque el pointer capture del swipe se tragaba el clic.
  var startX=0,startY=0,dx=0,drag=false,moved=false,w=0,baseX=0,downTarget=null;
  vp.addEventListener('pointerdown',function(e){
    drag=true; moved=false; w=vp.clientWidth; startX=e.clientX; startY=e.clientY; dx=0; downTarget=e.target;
    var m=track.style.transform.match(/-?[\d.]+/); baseX=m?parseFloat(m[0]):0;
    track.style.transition='none'; try{vp.setPointerCapture(e.pointerId);}catch(_){};
  });
  vp.addEventListener('pointermove',function(e){
    if(!drag)return; dx=e.clientX-startX;
    if(Math.abs(dx)>6||Math.abs(e.clientY-startY)>6) moved=true;
    if(moved) track.style.transform='translateX('+(baseX+dx)+'px)';
  });
  function endPtr(){
    if(!drag)return; drag=false;
    if(moved){ if(Math.abs(dx)>w*0.1){ dx<0?go(idx+1):go(idx-1); } else { center(true); } return; }
    // TAP (sin arrastre): video lateral -> centrarlo;  video activo -> activar/silenciar sonido
    var slide=downTarget&&downTarget.closest?downTarget.closest('.rv-slide'):null;
    if(slide){ var i=+slide.dataset.i; if(i!==idx){ go(i); } else { setSound(!soundOn); } }
  }
  vp.addEventListener('pointerup',endPtr); vp.addEventListener('pointercancel',endPtr);

  document.addEventListener('keydown',function(e){
    var r=root.getBoundingClientRect(); if(r.top>innerHeight*0.9||r.bottom<innerHeight*0.1) return;
    if(e.key==='ArrowRight') go(idx+1); else if(e.key==='ArrowLeft') go(idx-1);
  });
  window.addEventListener('resize',function(){ center(false); });

  if('IntersectionObserver' in window){
    new IntersectionObserver(function(es){ es.forEach(function(en){
      if(en.isIntersecting){ root.classList.add('in'); if(!started){ started=true; center(true); } }
      else { vids.forEach(function(v){ try{v.pause();}catch(_){} }); }
    }); },{threshold:.2}).observe(root);
  } else { root.classList.add('in'); started=true; center(true); }

  center(false);   // layout inicial centrado en el video del medio
})();
